export default "__VITE_ASSET__DNsbDncC__"